import { TRIAL_UPGRADE_NUDGE_COUNTDOWN_THRESHOLD_DAYS } from '../trial-upgrade-nudge/derive-trial-upgrade-nudge-state';
import type { CreditUsageTrialRemaining } from './types';

/**
 * Sidebar trigger shows the remaining count at the same 7-day threshold as
 * {@link TRIAL_UPGRADE_NUDGE_COUNTDOWN_THRESHOLD_DAYS}. Under 24 hours the
 * tile is still a day count, so it shows 0 instead of the leftover hours.
 */
export function resolveCreditUsageTriggerCountdown(
  trialRemaining: CreditUsageTrialRemaining | undefined
): number | undefined {
  if (trialRemaining == null) {
    return undefined;
  }
  if (trialRemaining.unit === 'hours') {
    return 0;
  }
  if (trialRemaining.value <= TRIAL_UPGRADE_NUDGE_COUNTDOWN_THRESHOLD_DAYS) {
    return trialRemaining.value;
  }
  return undefined;
}
